import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { ProductCardList as ProductCardListUI } from '@wix/premium-purchase-platform/@ui';
import React from 'react';
import styles from './ProductCardsSkeleton.scss';

export interface ProductCardsSkeletonProps {
  numCards?: number;
  dataHook?: string;
}

const CARD_LAYOUT = {
  height: '583px',
  borderRadius: '16px',
  maxWidth: '370px',
  padding: '20px',
  contentMarginTop: '75px',
  nameHeight: '20px',
  nameWidth: '93px',
  descriptionHeight: '12px',
  descriptionWidth: '147px',
  descriptionMarginTop: '7px',
  priceHeight: '33px',
  priceWidth: '123px',
  priceMarginTop: '31px',
  buttonHeight: '42px',
  buttonMarginTop: '23.5px',
  featureHeight: '12px',
  firstFeatureMarginTop: '21px',
  featureMarginTop: '25px',
  featureWidths: ['135px', '173px', '177px', '176px', '146px', '154px'],
};

export const ProductCardsSkeleton = ({
  numCards = 4,
  dataHook = 'product-cards-skeleton',
}: ProductCardsSkeletonProps) => {
  const skeletonClassName = styles.skeletonRectangle;

  return (
    <ProductCardListUI.Root
      gap={12}
      margin="0 auto"
      width="100%"
      dataHook={dataHook}
      className={styles.gradientFill}
    >
      {Array.from({ length: numCards }).map((_, index) => (
        <ProductCardListUI.Card.Root
          key={index}
          width="100%"
          maxWidth={CARD_LAYOUT.maxWidth}
          borderRadius={CARD_LAYOUT.borderRadius}
          height={CARD_LAYOUT.height}
          paddingLeft={CARD_LAYOUT.padding}
          paddingRight={CARD_LAYOUT.padding}
        >
          <Box width="100%" height="100%" align="left" direction="vertical">
            <SkeletonGroup className={styles.fullWidthColumn}>
              <Box
                direction="vertical"
                width="100%"
                marginTop={CARD_LAYOUT.contentMarginTop}
              >
                <SkeletonRectangle
                  className={skeletonClassName}
                  height={CARD_LAYOUT.nameHeight}
                  width={CARD_LAYOUT.nameWidth}
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height={CARD_LAYOUT.descriptionHeight}
                  width={CARD_LAYOUT.descriptionWidth}
                  marginTop={CARD_LAYOUT.descriptionMarginTop}
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height={CARD_LAYOUT.priceHeight}
                  width={CARD_LAYOUT.priceWidth}
                  marginTop={CARD_LAYOUT.priceMarginTop}
                />
                <SkeletonRectangle
                  className={skeletonClassName}
                  height={CARD_LAYOUT.buttonHeight}
                  width="100%"
                  marginTop={CARD_LAYOUT.buttonMarginTop}
                />
                {CARD_LAYOUT.featureWidths.map((featureWidth, featureIndex) => (
                  <SkeletonRectangle
                    key={featureIndex}
                    className={skeletonClassName}
                    height={CARD_LAYOUT.featureHeight}
                    width={featureWidth}
                    marginTop={
                      featureIndex === 0
                        ? CARD_LAYOUT.firstFeatureMarginTop
                        : CARD_LAYOUT.featureMarginTop
                    }
                  />
                ))}
              </Box>
            </SkeletonGroup>
          </Box>
        </ProductCardListUI.Card.Root>
      ))}
    </ProductCardListUI.Root>
  );
};
